import './Cell.scss';

const Cell_Text = ({ children, isSelected }) => {
  return <div className={`cell-text${isSelected ? ' selected' : ''}`}>{children}</div>;
};

export default Cell_Text;
